<template>

    <Page>

        <div class="grid grid-cols-2 gap-6">
                    
            <div class="grid grid-cols-1 md:grid-cols-3 gap-3 2xl:gap-4 w-[60vw] md:w-full max-w-[840px] text-black
                        py-10 scale-[75%] 2xl:scale-[80%]">
                                   
                <div class="bg-white rounded-lg p-1 flex flex-col">
                    <Image src="/Marketplace/dan-murphey.png"
                        class="w-full mb-1" 
                    />
                    <div class="px-1 text-xs text-cyan-600 font-bold">3% Cashback</div>
                    <div class="px-1 text-xs">Dan Murphey's eGift Card</div>
                </div>
                <div class="bg-white rounded-lg p-1 flex flex-col">
                    <Image src="/Marketplace/choice.png"
                        class="w-full mb-1" 
                    />
                    <div class="px-1 text-xs text-cyan-600 font-bold">3% Cashback</div>
                    <div class="px-1 text-xs">Choice Digital Visa Card</div>
                </div>
                <div class="bg-white rounded-lg p-1 flex flex-col">
                    <Image src="/Marketplace/big-w.png"
                        class="w-full mb-1" 
                    />
                    <div class="px-1 text-xs text-cyan-600 font-bold">3.7% Cashback</div>
                    <div class="px-1 text-xs">Big W eGift Card</div>
                </div>
                <div class="bg-white rounded-lg p-1 flex flex-col">
                    <Image src="/Marketplace/bws.png"
                        class="w-full mb-1" 
                    />
                    <div class="px-1 text-xs text-cyan-600 font-bold">3.5% Cashback</div>
                    <div class="px-1 text-xs">BWS eGift Card</div>
                </div>
                <div class="bg-white rounded-lg p-1 flex flex-col">
                    <Image src="/Marketplace/virgin.png"
                        class="w-full mb-1" 
                    />
                    <div class="px-1 text-xs text-cyan-600 font-bold">1.25% Cashback</div>
                    <div class="px-1 text-xs">Virgin Australia</div>
                </div>
                <div class="bg-white rounded-lg p-1 flex flex-col">
                    <Image src="/Marketplace/freely.png"
                        class="w-full mb-1" 
                    />
                    <div class="px-1 text-xs text-cyan-600 font-bold">8% Cashback</div>
                    <div class="px-1 text-xs">Freeliy Travel Insurance</div>
                </div>
                <div class="bg-white rounded-lg p-1 flex flex-col">
                    <Image src="/Marketplace/booking.png"
                        class="w-full mb-1" 
                    />
                    <div class="px-1 text-xs text-cyan-600 font-bold">Upo to 15% off + 3% Cashback</div>
                    <div class="px-1 text-xs">Booking.com</div>
                </div>
                <div class="bg-white rounded-lg p-1 flex flex-col">
                    <Image src="/Marketplace/omio.png"
                        class="w-full mb-1" 
                    />
                    <div class="px-1 text-xs text-cyan-600 font-bold">Up to 4% Cashback</div>
                    <div class="px-1 text-xs">Omio</div>
                </div>
                <div class="bg-white rounded-lg p-1 flex flex-col">
                    <Image src="/Marketplace/adidas.png"
                        class="w-full mb-1" 
                    />
                    <div class="px-1 text-xs text-cyan-600 font-bold">2% Cashback</div>
                    <div class="px-1 text-xs">Adidas Australia</div>
                </div>

                <div class="col-span-1 md:col-span-3 flex flex-col items-center basis-1/2 text-center px-6">
                    <h1 class="font-bold text-lg lg:text-xl 2xl:text-2xl 3xl:text-3xl text-white">
                        <span class="text-emerald-500">1,500+</span> Merchants in the program
                    </h1>
                    <h2 class="text-white/60 text-xs md:text-sm 2xl:text-base 3xl:text-lg">
                        Transferrable to other markets, available in +30 countries
                    </h2>
                    <h2 class="text-white/60 text-xs md:text-sm 2xl:text-base 3xl:text-lg">
                        ... or plug-in your existing rewards program! 
                    </h2>
                </div>

            </div>

            <div class=" flex flex-col items-center justify-center">

                <div class="mx-auto max-w-[440px] 2xl:max-w-[75%] 3xl:max-w-[70%]">

                    <Image 
                        src="/Marketplace/pay-by-card.jpg" 
                        class="mb-8 2xl:mb-16 !max-w-full md:!max-w-full lg:!max-w-full xl:!max-w-full 2xl:!max-w-full 3xl:max-w-full !w-full"
                        image-class=""
                        border
                    />

                    <div class="grid grid-cols-6 gap-1 w-full mx-auto text-black">
                        <div class="bg-white rounded-lg flex flex-col justify-center p-2">
                            <Image src="/Marketplace/visa.png" class="w-[90%] mx-auto" />
                        </div>
                        <div class="bg-white rounded-lg flex flex-col justify-center p-2">
                            <Image src="/Marketplace/mastercard.png" class="w-[70%] mx-auto" />
                        </div>
                        <div class="bg-white rounded-lg flex flex-col justify-center p-2">
                            <Image src="/Marketplace/eftpos.png" class="w-[90%] mx-auto" />
                        </div>
                        <div class="bg-white rounded-lg flex flex-col justify-center p-2">
                            <Image src="/Marketplace/google-pay.png" class="w-[70%] mx-auto" />
                        </div>
                        <div class="bg-white rounded-lg flex flex-col justify-center p-2">
                            <Image src="/Marketplace/samsung-pay.png" class="w-[70%] mx-auto" />
                        </div>
                        <div class="bg-white rounded-lg flex flex-col justify-center p-2">
                            <Image src="/Marketplace/apple-pay.png" class="w-[70%] mx-auto" />
                        </div>
                    </div>
                    
                </div>

                <div>
                    <div class="flex flex-col items-center basis-1/2 text-center py-2 px-6">
                        <h1 class="font-bold my-2 text-sm md:text-base xl:text-lg 3xl:text-2xl">
                            Extremely simple and  <span class="text-emerald-500">EASY</span> to use
                        </h1>
                        <h2 class="text-white/60 text-xs md:text-sm 2xl:text-base 3xl:text-lg">
                            No need to open the app at checkout, <span class="text-white font-semibold">just pay and go.</span>
                        </h2>
                        <h2 class="v">
                            <span class="text-white font-semibold">75%</span> of marketplace transactions are <span class="text-white font-semibold">tracked automatically.</span>
                        </h2>
                    </div>
                </div>

            </div>

        </div>

    </Page>

</template>